import ComponentV3 from "./componentv3.js"

export default class Component {
    constructor(adapter, source) {
        this.ref = null
        this.adapter = adapter
        this.client = adapter.getPlatformClient()
        this.source = source || 'platform-app'
        this.components = null
    }

    // backwards compatibility
    newByName(name) {
        return this.new(name)
    }

    // backwards compatibility
    getByTag(tag) {
       return this.new(tag)
    }

    new(ref) {
        return new ComponentV3(this.adapter, this.source).new(this.ref || ref)
    }

    v2(ref) {
        return this.new(ref)
    }

    v3(ref) {
        return this.new(ref)
    }
}